<template>
  <div>
    <div class="bank_tip">
      <div class="bank_tip_left">
        <i class="tip_prompt bank_tip_left_icon"></i>
        温馨提示：本页面价格均为基础价格（不包含可能存在的优惠），表中数据仅供参考，请以平台试算价格为准。<span class="update_time">更新时间：{{discountBestWebBaseCom.activeInfo.updateTime}}</span>
      </div>
      <div class="btn_text">
        <span @click="refresh">刷新</span>
        <span @click="download">下载</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['logo'],
  inject: ['discountBestWebBaseCom'],
  methods: {
    refresh () {
      this.discountBestWebBaseCom.refreshBankRate()
    },
    download () {
      this.discountBestWebBaseCom.downloadPage()
    },
  }
}
</script>

<style lang="less" scoped>
.bank_tip {
  display: flex;
  padding: 10px 36px 10px 20px;
  border: 1px solid #ffdeac;
  font-size: 12px;
  color: #f7a222;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff9e9;
  margin-bottom: 15px;
  .bank_tip_left {
    display: flex;
    align-items: center;
    .bank_tip_left_icon {
      display: inline-block;
      margin-right: 7px;
      width: 13px;
      height: 15px;
    }
  }
  .update_time {
    color: #666;
  }
  .btn_text {
    color: #e1241a;
    font-size: 14px;
    span {
      border-bottom: 1px solid #e1241a;
      cursor: pointer;
    }
    span:first-child {
      margin-right: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/DiscountBestRateCardTop.vue